import React from 'react';

import styles from './announcementStyles';

class Announcement extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  close() {
    this.setState({ closed: true });
  }

  render() {
    const { title, options, children } = this.props;
    const titleEl = title ? <h3 className={styles.announcementTitle}>{title}</h3> : '';
    const dismissableEl = options.dismissable ? (
      <span className={styles.announcementDismiss} onClick={this.close.bind(this)}>
        &times;
      </span>
    ) : (
      ''
    );

    if (this.state.closed) {
      return null;
    }

    return (
      <div className={styles.announcement}>
        <div className="announcementWrap">
          {titleEl}
          {children}
        </div>
        {dismissableEl}
      </div>
    );
  }
}

export default Announcement;
